import { LinkItem } from '@occc/ui-design-system';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';
import { OfferType, PartialOfferFragment } from '@occc-app/offerValidationService/types';
import { Offer_Funding_Source, OfferFragment } from '@occc/graphql';

import { getOfferComponentSubType, getOfferComponentType } from '@occc-app/offerHelpers/utils';
import { ComponentDetailsSectionVisibility } from '@occc-app/routes/CampaignComponents/component-details/component-details.types';
import { DEFAULT_COMPONENT_DETAILS_SECTION_VISIBILITY } from '@occc-app/routes/CampaignComponents/component-details/component-details.constants';
import { messages } from '../messages';
import { routeCreator } from '../utils';

export const getAwardDetailsPageHeaderLinks = (
  offerName?: string,
  offerId?: string,
): LinkItem[] => [
  {
    to: programManagementRouteCreator.base(),
    label: 'Program Management',
  },
  {
    to: routeCreator.base(),
    label: messages.title,
  },
  {
    key: offerId ? routeCreator.details(offerId) : routeCreator.base(),
    label: offerName,
  },
];

export const getAwardSubtype = (offer: OfferFragment | PartialOfferFragment) => {
  if (getOfferComponentType(offer) !== OfferType.Award) {
    return null;
  }
  return getOfferComponentSubType(offer);
};

export const fundingSourceMap: Record<Offer_Funding_Source, string> = {
  [Offer_Funding_Source.Brand]: 'Brand',
  [Offer_Funding_Source.Other]: 'Other',
  [Offer_Funding_Source.Partner]: 'Partner',
  [Offer_Funding_Source.Retailer]: 'Retailer',
};

export const getComponentDetailsVisibilityForAward = (
  offer: OfferFragment | PartialOfferFragment,
): ComponentDetailsSectionVisibility => {
  const subType = getAwardSubtype(offer);
  const visibility = { ...DEFAULT_COMPONENT_DETAILS_SECTION_VISIBILITY };

  if (subType === 'SweepstakeEntry' || subType === 'ExternalFulfillment') {
    return {
      ...visibility,
      targeting: false,
      constraints: false,
    };
  }

  return visibility;
};
